import React, { PureComponent } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import { connect } from 'react-redux';
import { withActions } from 'actionware';
import { getTranslate } from 'react-localize-redux';
import { fetchLenderAccounts } from '../account/accountActions';
import { authLogout } from '../login/loginActions';
import * as classnames from 'classnames';
import { getInitials } from '../../common/helpers';
import * as R from 'ramda';
// We use the core Item and SubMenu components from rc as the Menu.Item
// component from ant design has a nasty tooltip bug
import { Item, SubMenu } from 'rc-menu';
import { matchPath } from 'react-router';
import { toggleAccountCreationModal } from '../accountCreation/accountCreationActions';
import { getRole } from '../../common/helpers';

@withRouter
@connect(({ session, localize, account: { accounts } }) => ({
  userName: R.pathOr('', ['user', 'user', 'name'], session),
  memberSince: R.pathOr('', ['user', 'memberSince'], session),
  translate: getTranslate(localize),
  loggedIn: !!(session && session.authenticated && session.user),
  accounts
}))
@withActions({
  fetchLenderAccounts,
  toggleAccountCreationModal,
  authLogout
})
export default class NavMenuMobile extends PureComponent {
  state = {
    collapsed: false,
    openKeys: [],
    role: ''
  };

  async componentDidUpdate(prevProps, prevState) {
    const role = await getRole();
    this.setState({ role });
    if (this.state.openKeys === prevState.openKeys) {
      // Check the current path to know if it is necessary to open some submenus
      const { location: { pathname } } = this.props;
      const openKeyLink = this.navLinkPaths.find(
        ({ path, submenu }) =>
          submenu &&
          submenu.some(({ path }) =>
            matchPath(pathname, { path, exact: true })
          ),
        []
      );
      if (openKeyLink) {
        this.setState({
          openKeys: [openKeyLink.path]
        });
      } else if (this.state.openKeys.length) {
        this.setState({
          openKeys: []
        });
      }
    }
  }
  onClickAddAccount = e => {
    e.preventDefault(); // prevent page transition
    this.props.toggleAccountCreationModal();
  };

  get navLinkPaths() {
    const { translate } = this.props;
    const { role } = this.state;
    const loggedInLinks = this.props.loggedIn
      ? [
          {
            label: translate('nav.loan'),
            path: '/loan',
            exact: true
          }
        ]
      : [];
      if (['LENDER'].includes(role)) {
        loggedInLinks.push({
          label: translate('nav.approval'),
          path: '/approval',
          exact: true
        });
      }
      if (['FINANCE'].includes(role)) {
        loggedInLinks.push({
          label: translate('nav.transaction'),
          path: '/transaction',
          exact: true
        });
      }
      if (['ADMIN'].includes(role)) {
        loggedInLinks.push({
          label: translate('nav.ovo_admin_tab_title_funding_limit'),
          path: '/funding-limit',
          exact: true
        });
      }
    return [
      { label: translate('nav.home'), path: '/', exact: true },
      ...loggedInLinks,
      // {
      //   label: translate('nav.history'),
      //   path: '/history',
      //   exact: true
      // },
      // {
      //   label: translate('nav.account'),
      //   path: '/account',
      //   exact: false,
      //   submenu: [
      //     {
      //       label: translate('nav.createNewAccount'),
      //       path: '/addNewAccount',
      //       className: 'add-new-account',
      //       onClick: this.onClickAddAccount
      //     }
      //   ].concat(
      //     accounts.map(({ name, id }) => ({
      //       label: name,
      //       path: `/account/${id}`
      //     }))
      //   )
      // },
      // {
      //   label: translate('nav.account'),
      //   path: `/account/${accounts[0] && accounts[0].id}`,
      //   exact: true
      // },
      {
        label: translate('nav.profile'),
        path: '/profile',
        exact: true
      },
      {
        label: translate('nav.signout'),
        path: '/signout',
        exact: true,
        onClick: e => {
          e.preventDefault(); // prevent page transition
          this.props.authLogout();
        }
      }
    ];
  }

  renderSubmenu(label, key, submenu) {
    return (
      <SubMenu closesubmenuonmouseleave="false" title={label} key={key}>
        {submenu.map(({ label, path, onClick, className }) => (
          <Item key={path} className={className}>
            <Link to={{ pathname: path }} onClick={onClick}>
              {label}
            </Link>
          </Item>
        ))}
      </SubMenu>
    );
  }

  getMenuItems() {
    return this.navLinkPaths.map(
      ({ label, path, exact, submenu, onClick }, key) =>
        submenu ? (
          this.renderSubmenu(label, path, submenu)
        ) : (
          <Item key={path}>
            <Link to={{ pathname: path }} onClick={onClick}>
              {label}
            </Link>
          </Item>
        )
    );
  }

  updateOpenKeys = openKeys => {
    this.setState({ openKeys });
  };

  collapseMenu = () => {
    this.setState({
      collapsed: true
    });
  };

  onCollapse = collapsed => {
    this.setState({
      collapsed
    });
  };

  render() {
    const { userName, translate, location: { pathname } } = this.props;
    const nameInitials = getInitials(userName);

    return (
      <Layout.Sider
        collapsed={this.state.collapsed}
        breakpoint="lg"
        collapsedWidth="0"
        onCollapse={this.onCollapse}
        width={260}
      >
        <div className="sider-header">
          <div className={'name-badge'}>{nameInitials}</div>
          <div>
            <h1>{userName}</h1>
            <div className={'user-info'}>
              {
                // translate('nav.lenderSince', {
                //  date: moment(this.props.memberSince).format('MMMM YYYY')
                // })
              }
            </div>
          </div>
        </div>
        <Menu
          closesubmenuonmouseleave="false"
          onOpenChange={this.updateOpenKeys}
          onClick={this.collapseMenu}
          mode="inline"
          style={{ borderRight: 0, width: '100%' }}
          selectedKeys={[pathname]}
          openKeys={this.state.openKeys}
        >
          {this.getMenuItems()}
        </Menu>
        <div
          onClick={this.collapseMenu}
          className={classnames('content-overlay', {
            visible: !this.state.collapsed
          })}
        />
      </Layout.Sider>
    );
  }
}
